import FreigthForwarder from ".";

export const freigthForwarderRoutes = [
  {
    path: "/freigthForwarders",
    element: <FreigthForwarder />,
  },
];
